module.exports = __webpack_public_path__ + "img/GroupSingleTrip.a3cc7c3a.png";